export * from './network';
export * from './numbers';
export * from './points';
export * from './timeAndDates';
export * from './tokens';
export * from './apy';

export const PERMISSION_LEVELS = {
  PRIVATE: 0,
  FUNCTION_LEVEL: 1,
  POOL_LEVEL: 2,
  PUBLIC: 3,
};

export const POLLING_INTERVAL = 15000; // 15 seconds

// Pendle
const PENDLE_CONTRACT_URL = '0x9a63fa80b5ddfd3cab23803fdb93ad2c18f3d5aa';
const PENDLE_URL_BASE = 'https://app.pendle.finance';
// export const PENDLE_LINK_MARKET = `${PENDLE_URL_BASE}/trade/markets/${PENDLE_CONTRACT_URL}`;
// export const PENDLE_LINK_LP = `${PENDLE_URL_BASE}/pools/markets/${PENDLE_CONTRACT_URL}`;
export const PENDLE_LINK_POINTS = `${PENDLE_URL_BASE}/trade/points/${PENDLE_CONTRACT_URL}`;

// Circle
export const CIRCLE_GITBOOK_URL = 'https://maplefinance.gitbook.io/maple/syrupusdc-rewards-prize-draw-program-summary';
export const CIRCLE_TERMS_URL =
  'https://maplefinance.gitbook.io/maple/legal/syrupusdc-rewards-prize-draw-terms-and-conditions';
export const CIRCLE_END_DATE = '2025-05-31';

// Morpho
export const MORPHO_API_URL = 'https://blue-api.morpho.org/graphql';
export const MORPHO_URL_BASE = 'https://app.morpho.org';
export const MORPHO_SYRUP_USDC_MARKET = '0x729badf297ee9f2f6b3f717b96fd355fc6ec00422284ce1968e76647b258cf44';

// Gitbook
export const GITBOOK_TERMS_URL =
  'https://maplefinance.gitbook.io/maple/legal/interface-terms-of-use-syrupusdc-and-syrupusdt';
export const GITBOOK_TERMS_CONVERT_URL =
  'https://maplefinance.gitbook.io/maple/legal/interface-terms-of-use-syrup.fi-convert-and-syrup.fi-stake';
export const GITBOOK_FAQ_URL = 'https://maplefinance.gitbook.io/maple/faq';
export const GITBOOK_DOCS_URL = 'https://maplefinance.gitbook.io/maple/syrupusdc-for-lenders/introduction';
export const GITBOOK_PRIVACY_URL = 'https://maplefinance.gitbook.io/maple/legal/syrupusdc-and-syrupusdt-privacy-policy';
export const GITBOOK_DRIPS_CLAIM_URL = 'https://maplefinance.gitbook.io/maple/maple-for-token-holders/drips-rewards';

// Feat flags
// ------------------------------

// - Template
// export const isFooEnabled = process.env.REACT_APP_FOO_ENABLED
//   ? JSON.parse(process.env.REACT_APP_FOO_ENABLED)
//   : false;

export const isEarnEnabled = process.env.REACT_APP_EARN_ENABLED
  ? JSON.parse(process.env.REACT_APP_EARN_ENABLED)
  : false;

export const isSyrupWeeklyEnabled = process.env.REACT_APP_SYRUP_WEEKLY_ENABLED
  ? JSON.parse(process.env.REACT_APP_SYRUP_WEEKLY_ENABLED)
  : false;

export const isCircleEnabled = process.env.REACT_APP_CIRCLE_ENABLED
  ? JSON.parse(process.env.REACT_APP_CIRCLE_ENABLED)
  : false;

export const isRebrandEnabled = process.env.REACT_APP_REBRAND_ENABLED
  ? JSON.parse(process.env.REACT_APP_REBRAND_ENABLED)
  : false;

export const isRedirectEnabled = process.env.REACT_APP_REDIRECT_ENABLED
  ? JSON.parse(process.env.REACT_APP_REDIRECT_ENABLED)
  : false;
